module.exports = __webpack_public_path__ + "img/ofd.f9a0aab9.png";